<template>
  <div class="py-6 text-white footer">
    <v-container>
      <v-row class="pb-3">
        <v-col cols="12" lg="6" sm="6">
          <h3 className="font-weight-bold">Drive On</h3>
          <small
            >Et rebum sadipscing ipsum elitr invidunt ipsum lorem sea voluptua
            elitr,<br />
            accusam clita accusam consetetur diam consetetur.<br />
            Sea gubergren amet.</small
          >
        </v-col>
        <v-col cols="12" lg="3" sm="3">
          <h5 className="mb-2">Quick View</h5>
          <h6 className="opacity-75">Home</h6>
          <h6 className="opacity-75">About</h6>
          <h6 className="opacity-75">Our Service</h6>
          <h6 className="opacity-75">Contact Us</h6>
        </v-col>
        <v-col cols="12" lg="3" sm="3">
          <h5 className="mb-2">Contact</h5>
          <h6 className="opacity-75">1004, Marcov Street</h6>
          <h6 className="opacity-75">San Diago, Eastcoast</h6>
          <a
            href="mailto:drive@gmail.com"
            className="d-block text-white text-body-2 text-decoration-none opacity-75"
            >drive@gmail.com</a
          >
          <a
            href="tel:+024598743"
            className="text-white text-body-2 text-decoration-none opacity-75"
            >Tel:+024598743</a
          >
        </v-col>
      </v-row>
      <hr class="mb-3">
      <div class="d-flex justify-space-between">
        <small class="">Copyright&#169; 2022, Drive-On All Rights Reserved</small>
      <div>
        <v-icon class="mr-3">mdi-facebook</v-icon>
        <v-icon class="mr-3">mdi-instagram</v-icon>
        <v-icon class="mr-3">mdi-twitter</v-icon>
      </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  background-color: rgb(68, 38, 151);
}
</style>